(() => {
  const root = document.querySelector(".ha-quiz");
  if (!root) return;

  const form = root.querySelector("[data-quiz]");
  const screens = [...form.querySelectorAll("[data-screen]")];
  const progressFill = root.querySelector("[data-progress]");
  const stepCounter = root.querySelector("[data-step-counter]");
  const backBtn = root.querySelector("[data-back]");
  const ctaUrl = root.dataset.ctaUrl || "/collections/all";
  const summaryLabels = {
    age: "Age range",
    body: "How your body feels",
    symptoms: "Recent symptoms",
    stage: "Stage",
    puffiness: "Puffiness timing",
    tried: "What you've tried",
    consistency: "Supplement consistency",
    sleep: "Sleep",
    goals: "Goals",
  };

  const total = screens.length;
  let index = 0;
  const history = [];

  function setStep(next, push = true) {
    if (next < 0 || next >= screens.length) return;
    if (push && next !== index) history.push(index);
    screens[index].classList.remove("is-active");
    index = next;
    const screen = screens[index];
    screen.classList.add("is-active");

    const pct = Math.round(((index + 1) / total) * 100);
    progressFill.style.width = pct + "%";
    stepCounter.textContent = `${index + 1} / ${total}`;
    backBtn.hidden = history.length === 0;

    window.scrollTo({ top: 0, behavior: "smooth" });

    const screenName = screen.dataset.screen;
    location.hash = screenName;

    if (screenName === "loader") runLoader(screen);
    if (screenName === "trust") initCarousel(screen);
    if (screenName === "summary") renderSummary(screen);
    if (screenName === "bridge") renderBridge(screen);
    if (screenName === "result") {
      const cta = screen.querySelector("[data-cta]");
      if (cta) cta.href = ctaUrl;
    }

    setTimeout(() => {
      const firstInput = screen.querySelector("input");
      if (firstInput) firstInput.focus({ preventScroll: true });
    }, 50);
  }

  function isAnswered(screen) {
    if (!screen.hasAttribute("data-required")) return true;
    const inputs = screen.querySelectorAll("input[type=radio], input[type=checkbox]");
    return [...inputs].some((i) => i.checked);
  }

  function runLoader(screen) {
    const items = [...screen.querySelectorAll("[data-step]")];
    const ms = parseInt(screen.dataset.autoAdvance || "4500", 10);
    const each = Math.max(400, Math.floor(ms / items.length));
    items.forEach((it) => it.classList.remove("is-active", "is-done"));
    items.forEach((item, i) => {
      setTimeout(() => {
        items.forEach((x) => x.classList.remove("is-active"));
        item.classList.add("is-active");
        if (i > 0) items[i - 1].classList.add("is-done");
      }, each * i);
    });
    setTimeout(() => {
      items.forEach((x) => x.classList.remove("is-active"));
      items.forEach((x) => x.classList.add("is-done"));
      setStep(index + 1);
    }, each * items.length);
  }

  function getAnswers() {
    const data = new FormData(form);
    const out = {};
    for (const [k, v] of data.entries()) {
      if (out[k] === undefined) out[k] = v;
      else if (Array.isArray(out[k])) out[k].push(v);
      else out[k] = [out[k], v];
    }
    return out;
  }

  function renderSummary(screen) {
    const answers = getAnswers();
    const arr = (k) => (answers[k] ? (Array.isArray(answers[k]) ? answers[k] : [answers[k]]) : []);

    // Subscores 0-100 (higher = better support)
    const symptoms = arr("symptoms");
    const goals = arr("goals");
    const sleep = answers.sleep || "";
    const tried = answers.tried || "";
    const consistency = answers.consistency || "";
    const body = answers.body || "";
    const puffiness = answers.puffiness || "";

    const symHas = (s) => symptoms.some((x) => x.toLowerCase().includes(s));
    const goalHas = (s) => goals.some((x) => x.toLowerCase().includes(s));

    // Cellular energy & NAD+
    let energy = 70;
    if (body.includes("Energy")) energy -= 25;
    if (symHas("afternoon")) energy -= 20;
    if (sleep.includes("tired") || sleep.includes("Trouble")) energy -= 15;
    if (sleep === "Solid") energy += 10;
    if (goalHas("energy")) energy -= 5;

    // Hormonal balance
    let bodyScore = 70;
    const stage = answers.stage || "";
    if (stage === "Perimenopause") bodyScore -= 18;
    else if (stage === "Menopause" || stage === "Postmenopause") bodyScore -= 25;
    if (symHas("mood") || symHas("waistline") || symHas("weight")) bodyScore -= 15;
    if (puffiness === "Around cycle") bodyScore -= 10;
    if (tried.includes("Hormone")) bodyScore -= 5;

    // Sleep & recovery
    let digestion = 70;
    if (sleep.includes("Wakes") || sleep.includes("Trouble") || sleep.includes("tired")) digestion -= 28;
    if (sleep === "Solid") digestion += 12;
    if (sleep === "Depends") digestion -= 10;
    if (goalHas("sleep")) digestion -= 8;

    // Inflammation & puffiness
    let micro = 70;
    if (symHas("puffiness") || symHas("bloating")) micro -= 28;
    if (consistency.includes("Forget") || consistency === "Hit or miss") micro -= 12;
    if (tried === "Nothing yet") micro -= 12;
    if (puffiness === "Morning" || puffiness === "After meals") micro -= 8;

    const clamp = (n) => Math.max(8, Math.min(95, Math.round(n)));
    energy = clamp(energy);
    bodyScore = clamp(bodyScore);
    digestion = clamp(digestion);
    micro = clamp(micro);

    const overall = Math.round((energy + bodyScore + digestion + micro) / 4);

    const labelFor = (n) =>
      n < 30 ? "Below optimal" :
      n < 55 ? "Room for improvement" :
      n < 75 ? "Approaching optimal" :
      "Strong";

    const badgeFor = (n) =>
      n < 25 ? "LOW" :
      n < 50 ? "LOW-MODERATE" :
      n < 70 ? "MODERATE" :
      n < 85 ? "GOOD" :
      "HIGH";

    screen.querySelector("[data-result-badge]").textContent = badgeFor(overall);
    const fill = screen.querySelector("[data-gauge-fill]");
    const marker = screen.querySelector("[data-gauge-marker]");
    if (fill) fill.style.width = overall + "%";
    if (marker) marker.style.left = overall + "%";

    screen.querySelector("[data-card='energy']").textContent = labelFor(energy);
    screen.querySelector("[data-card='body']").textContent = labelFor(bodyScore);
    screen.querySelector("[data-card='digestion']").textContent = labelFor(digestion);
    screen.querySelector("[data-card='micronutrients']").textContent = labelFor(micro);

    // Primary focus area = the weakest subscore (the root cause to address first)
    const focusMap = { energy: "Cellular energy & NAD+", body: "Hormonal balance", digestion: "Sleep & recovery", micro: "Inflammation & puffiness" };
    const subs = { energy: energy, body: bodyScore, digestion: digestion, micro: micro };
    const weakest = Object.keys(subs).reduce((a, b) => (subs[a] <= subs[b] ? a : b));
    const focusEl = screen.querySelector("[data-primary-focus]");
    if (focusEl) focusEl.textContent = focusMap[weakest];

    // Personalize alert copy
    const title = screen.querySelector("[data-alert-title]");
    const copy = screen.querySelector("[data-alert-copy]");
    if (overall < 50) {
      title.textContent = "Your body's longevity engine needs more consistent support.";
      copy.textContent = "After 40, NAD+ levels drop by up to 50%. The signals you're describing, like low energy, puffiness, and restless sleep, often trace back to this gradual decline.";
    } else if (overall < 75) {
      title.textContent = "You're doing well, but there's room to unlock more energy and resilience.";
      copy.textContent = "A few targeted longevity inputs (NAD+, hormonal cofactors, sleep support) can lift how you feel noticeably within a few weeks.";
    } else {
      title.textContent = "You're in a strong place. Let's help you stay there as you age.";
      copy.textContent = "Consistent NAD+ support compounds over time, so you keep the energy, glow, and clarity you've worked for as life gets busier.";
    }

    try {
      sessionStorage.setItem(
        "ha_quiz_answers",
        JSON.stringify({ answers, scores: { overall, energy, body: bodyScore, digestion, micro } })
      );
    } catch (e) {}
  }

  // Projection: stamp a personalized ~12-week date on the bridge screen
  function renderBridge(screen) {
    const el = screen.querySelector("[data-projection-date]");
    if (!el) return;
    const d = new Date();
    d.setDate(d.getDate() + 84);
    el.textContent = d.toLocaleDateString("en-US", { month: "long", day: "numeric" });
  }

  // Carousel
  function initCarousel(screen) {
    const car = screen.querySelector("[data-carousel]");
    if (!car || car.dataset.inited === "1") return;
    car.dataset.inited = "1";
    const track = car.querySelector("[data-track]");
    const slides = track.children;
    const dots = [...car.querySelectorAll("[data-dot]")];
    const prev = car.querySelector("[data-prev]");
    const next = car.querySelector("[data-next-slide]");
    const autoplayMs = parseInt(car.dataset.autoplay || "0", 10);
    let i = 0;
    let timer = null;

    const render = () => {
      track.style.transform = `translateX(-${i * 100}%)`;
      dots.forEach((d, idx) => d.classList.toggle("is-active", idx === i));
    };
    const go = (delta) => {
      i = (i + delta + slides.length) % slides.length;
      render();
      restart();
    };
    const restart = () => {
      if (!autoplayMs) return;
      clearInterval(timer);
      timer = setInterval(() => go(1), autoplayMs);
    };
    prev.addEventListener("click", (e) => { e.stopPropagation(); go(-1); });
    next.addEventListener("click", (e) => { e.stopPropagation(); go(1); });
    dots.forEach((d, idx) => d.addEventListener("click", (e) => { e.stopPropagation(); i = idx; render(); restart(); }));

    // touch swipe
    let startX = 0;
    track.addEventListener("touchstart", (e) => { startX = e.touches[0].clientX; }, { passive: true });
    track.addEventListener("touchend", (e) => {
      const dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1);
    });

    render();
    restart();
  }

  // wire up "next" buttons
  form.addEventListener("click", (e) => {
    const next = e.target.closest("[data-next]");
    if (!next) return;
    e.preventDefault();
    const screen = screens[index];
    if (!isAnswered(screen)) {
      next.animate(
        [
          { transform: "translateX(0)" },
          { transform: "translateX(-6px)" },
          { transform: "translateX(6px)" },
          { transform: "translateX(0)" },
        ],
        { duration: 240 }
      );
      return;
    }
    setStep(index + 1);
  });

  // auto-advance for radio (single-select), not checkbox
  form.addEventListener("change", (e) => {
    const screen = screens[index];
    if (e.target.type !== "radio") return;
    if (screen.hasAttribute("data-multi")) return;
    setTimeout(() => setStep(index + 1), 220);
  });

  // back
  backBtn.addEventListener("click", () => {
    if (!history.length) return;
    const prev = history.pop();
    screens[index].classList.remove("is-active");
    index = prev;
    screens[index].classList.add("is-active");
    const pct = Math.round(((index + 1) / total) * 100);
    progressFill.style.width = pct + "%";
    stepCounter.textContent = `${index + 1} / ${total}`;
    backBtn.hidden = history.length === 0;
    window.scrollTo({ top: 0, behavior: "smooth" });
    location.hash = screens[index].dataset.screen;
  });

  // initial
  progressFill.style.width = `${Math.round((1 / total) * 100)}%`;
  stepCounter.textContent = `1 / ${total}`;
})();
